import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

/** Iniciais para o fallback: "Flávio Bitencourt" → "FB"; "Fabianne" → "F". */
export function iniciaisDe(nome: string | null | undefined): string {
  if (!nome) return '?';
  const partes = nome.trim().split(/\s+/);
  return ((partes[0]?.[0] ?? '') + (partes.length > 1 ? partes[partes.length - 1][0] : '')).toUpperCase();
}

const TAMANHO = { xs: 'h-4 w-4 text-[7px]', sm: 'h-5 w-5 text-[8.5px]', md: 'h-6 w-6 text-[10px]' } as const;

/**
 * Foto da pessoa com iniciais como reserva. É o átomo de "quem" em todo seletor e card do
 * app: onde aparece um nome de usuário, aparece a foto ao lado.
 */
export function PessoaAvatar({ nome, avatarUrl, tamanho = 'sm', className }: {
  nome: string | null | undefined; avatarUrl?: string | null; tamanho?: keyof typeof TAMANHO; className?: string;
}) {
  return (
    <Avatar className={cn('shrink-0', TAMANHO[tamanho], className)}>
      {avatarUrl ? <AvatarImage src={avatarUrl} alt="" /> : null}
      <AvatarFallback className="bg-muted font-semibold text-muted-foreground">{iniciaisDe(nome)}</AvatarFallback>
    </Avatar>
  );
}

/** Foto + nome na mesma linha: o conteúdo de um `SelectItem` ou de uma célula. */
export function PessoaLinha({ nome, avatarUrl, tamanho = 'sm', className }: {
  nome: string | null | undefined; avatarUrl?: string | null; tamanho?: keyof typeof TAMANHO; className?: string;
}) {
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2', className)}>
      <PessoaAvatar nome={nome} avatarUrl={avatarUrl} tamanho={tamanho} />
      <span className="truncate">{nome ?? '—'}</span>
    </span>
  );
}
